'use strict';

const Item = require('bunsen/models/inventory/Item');
const Seller = require('bunsen/models/Seller');
const User = require('bunsen/models/identity/User');
const AnchorLists = require('bunsen/collections/identity/AnchorLists');
const Conversation = require('bunsen/models/usercomm/Conversation');
const Deferred = require('simply-deferred').Deferred;

module.exports = {
    loadItem(itemPk) {
        const item = new Item({ id: itemPk });
        return item.fetch({ data: { fields: 'full,sellerInfo,key' } }).then(() => {
            return {
                item,
                seller: item.get('seller'),
            };
        });
    },

    loadSeller(sellerPk, preloadedSeller) {
        if (preloadedSeller) {
            return Deferred().resolve({ seller: preloadedSeller });
        }
        const seller = new Seller({ id: sellerPk });
        return seller.fetch({ data: { fields: Seller.FIELD_PREFERENCE } }).then(() => {
            return { seller };
        });
    },

    /**
     * returns {Object} Deferred resolving to user model if user is authenticated
     */
    loadUser() {
        // note: User.gotCurrentUser will return a user model with id='me' if none was found
        return User.gotCurrentUser().then(user => (/\d/.test(user.id) ? user : null));
    },

    // save inserted name to user's profile if they don't already have one set
    saveName(options) {
        const { userProfile, fullName } = options;
        if (!userProfile.get('firstName') && !userProfile.get('lastName')) {
            return userProfile.setDisplayName(fullName).save();
        }
        return Deferred().resolve();
    },

    /**
     * returns {Object} Deferred resolving to true if the user is able to opt in to
     * sharing their email address
     */
    checkEmailOptIn(options) {
        const { dealerId, itemId } = options;
        const anchorLists = new AnchorLists();
        const conversation = new Conversation();
        return anchorLists
            .fetchSellerOnList(dealerId, AnchorLists.listNames.OPOP, 'SELLER_POLICY')
            .then(
                () => {
                    // do not show opt in if dealer is on new policy
                    if (anchorLists.length > 0) {
                        return false;
                    }
                    if (!User.getUserId()) {
                        // buyer is logged out -- will not check conversation history
                        return true;
                    }
                    // general inquiry
                    if (!itemId) {
                        return true;
                    }
                    return conversation
                        .fetchConversationForBuyerAndItem({
                            buyerId: User.getUserId(),
                            itemId,
                        })
                        .then(
                            // conversation exists between this buyer/item - user cannot opt in
                            () => false,
                            // if conversation is not found - user can opt in
                            response => Deferred().resolve(response.status === 404)
                        );
                },
                () => Deferred().resolve(false)
            );
    },

    constructItemSubject(options) {
        const { prefix, item } = options;
        return [prefix, item.get('title'), item.get('dibsReference')].join(' - ');
    },
};



// WEBPACK FOOTER //
// ./assets/js/contact/shared/helpers/contactHelpers.es.js